import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/administration/_administration/legal-holiday/_legal-holiday')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.legalHolidays' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
